import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
};
export function Section({
  id,
  children,
  className = ''
}: SectionProps) {
  return <section id={id} className={`w-full px-5 py-16 sm:py-20 lg:py-24 ${className}`} data-id="element-165" data-mp="3fxf6jqog3gu5">
      <div className="mx-auto w-full max-w-4xl" data-id="element-166" data-mp="3kuoqwrwz92b4">{children}</div>
    </section>;
}
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    ease: [0.21, 0.47, 0.32, 0.98],
    delay
  }} data-id="element-167" data-mp="hgkm7uxp08j7">
      {children}
    </motion.div>;
}